const BASE_FONT_SIZE = 16;
export const calcRem = pixels => `${pixels / BASE_FONT_SIZE}rem`;
